/**
 * MifeLife v2 — AuthCallback (Emergent OAuth landing).
 *
 * Mounted by App.js BEFORE Routes when window.location.hash contains
 * `session_id=`. Parses the fragment synchronously, POSTs to backend,
 * stores JWT, redirects to /app.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import React, { useEffect, useRef, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { apiRequest, setToken, setUser } from '../../lib/utils';
import { useNoIndex } from '../../hooks/useNoIndex';

export default function V2AuthCallbackPage() {
  useNoIndex();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = window.location.hash || '';
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { window.location.replace('/giris'); return; }
      const sessionId = decodeURIComponent(m[1]);
      try {
        const res = await apiRequest('/v2/auth/google-callback', {
          method: 'POST',
          body: JSON.stringify({ session_id: sessionId, intent: 'personal' }),
        });
        if (res?.access_token) {
          setToken(res.access_token);
          if (res.user) setUser(res.user);
        }
        // Clear the hash and route to intended destination (mentor panel, etc).
        window.history.replaceState(null, '', window.location.pathname);
        const after = sessionStorage.getItem('mife_after_login');
        sessionStorage.removeItem('mife_after_login');
        window.location.replace(after || '/app');
      } catch (e) {
        setErr(e?.message || 'Google girişi başarısız.');
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#0F0F1A] text-white flex flex-col items-center justify-center" data-testid="v2-auth-callback">
      <Loader2 className="w-7 h-7 text-violet-300 animate-spin mb-4" />
      <div className="text-sm text-slate-400">{err || 'Google ile bağlanıyor…'}</div>
      {err && <a href="/giris" className="mt-4 text-xs text-violet-300 underline">Tekrar dene</a>}
    </div>
  );
}
